require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-loco-jam-summit-djs-cruise.json") })
        }
      }, "path---interview-loco-jam-summit-djs-cruise");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-loco-jam-summit-djs-cruise!./.cache/json/interview-loco-jam-summit-djs-cruise.json
// module id = 688
// module chunks = 231608221292675